var getNodeHttpModules = function getNodeHttpModules() {
  try {
    return Promise.resolve({
      nodeHttpsTransport: undefined,
      nodeHttpTransport: undefined
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

exports.getNodeHttpModules = getNodeHttpModules;
//# sourceMappingURL=util-node-http-modules.noop.js.map
